<div class="content-wrapper">
	<div class="content-wrapper">
		<div class="content-body">

			<!-- content-header component -->
			<app-content-header [contentHeader]="contentHeader"></app-content-header>

			<div class="card">

				<!-- TABELA DE DADOS -->
				<section id="ngx-datatable-inline-editing">
					<!-- FUNCOES DA TABELA -->
					<div class="row">
						<div class="col-12">
							<button class="btn btn-primary float-right mr-1 mt-1" routerLink="/pedido/cadastro/isencao"
								rippleEffect>
								<i data-feather="plus" class="mr-0 mr-sm-1"></i><span
									class="d-none d-sm-inline-block">Novo <b>pedido de isenção</b></span>
							</button>
							<!-- <a csvLink [data]="exportCSVData" class="btn btn-outline-secondary float-right mr-1 mt-1" rippleEffect>Exportar
                                        CSV</a> -->
						</div>
					</div>
					<hr>
					<!-- FILTROS DA TABELA -->
					<div class="row">
						<div class="col-md-6 col-12">
							<div class="d-flex justify-content-between align-items-center m-1">
								<label class="d-flex align-items-center">Mostrar
									<select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
										<option value="10">10</option>
										<option value="25">25</option>
										<option value="50">50</option>
										<option value="100">100</option>
									</select>
								</label>
							</div>
						</div>
					</div>

					<!-- DATATABLE -->
					<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
						[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
						[loadingIndicator]="starting" style="box-shadow: none" [rows]="rows" [scrollbarH]="true">

						<!-- COLUNA ID PEDIDO -->
						<!-- <ngx-datatable-column name="ID" prop="id_pedido_isencao" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>ID Pedido</h4>
								<input type="search" placeholder="ID Pedido" class="ml-25 form-control"
									(keyup)="idPedidoFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">#{{row.id_pedido_isencao}}</span>
							</ng-template>
						</ngx-datatable-column> -->

						<!-- COLUNA CLIENTE -->
						<ngx-datatable-column name="Cliente" prop="cliente_nome" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Cliente</h4>
								<input type="search" placeholder="Cliente" class="ml-25 form-control"
									(keyup)="clienteFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="badge badge-pill badge-light-secondary">
									{{ row.cliente_nome || '-' }}
								</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA PRODUTO -->
						<ngx-datatable-column name="Produto" prop="produto_nome" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Produto</h4>
								<input type="search" placeholder="Produto" class="ml-25 form-control"
									(keyup)="produtoFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">{{row.produto_nome || '-'}}</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA STATUS -->
						<ngx-datatable-column name="Status" prop="id_status" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Status</h4>
								<select [(ngModel)]="selectedStatus" (change)="statusFilter()"
									class="ml-25 form-control" name="" id="">
									<option [value]="0">Todos</option>
									<option [value]="1">Ativo</option>
									<option [value]="2">Inativo</option>
								</select>
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="badge badge-pill badge-light-success" *ngIf="row.id_status == 1">Ativo</span>
								<span class="badge badge-pill badge-light-danger" *ngIf="row.id_status == 2">Inativo</span>
								<span class="badge badge-pill badge-light-secondary" *ngIf="!row.id_status || row.id_status == 0">-</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA DATA COMPRA -->
						<ngx-datatable-column name="DtCompra" prop="dt_compra" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Data Compra</h4>
								<input type="search" placeholder="Data Compra" class="ml-25 form-control"
									mask="00/00/0000" (keyup)="dtCompraFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">{{row.dt_compra | date:'dd/MM/yyyy'}}</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA DATA FIM ISENÇÃO -->
						<ngx-datatable-column name="DtFimIsencao" prop="dt_fim_isencao" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Fim Isenção</h4>
								<input type="search" placeholder="Fim Isenção" class="ml-25 form-control"
									mask="00/00/0000" (keyup)="dtFimIsencaoFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">{{row.dt_fim_isencao | date:'dd/MM/yyyy'}}</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA DATA INSERT -->
						<ngx-datatable-column name="DtInsert" prop="dt_insert" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Data Cadastro</h4>
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">{{row.dt_insert | date:'dd/MM/yyyy HH:mm':'UTC'}}</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA AÇÕES -->
						<ngx-datatable-column [width]="20" [sortable]="false">
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<div class="d-flex align-items-center" style="float: right">
									<div ngbDropdown container="body">
										<a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow"
											id="dropdownBrowserState" data-toggle="dropdown" aria-haspopup="true"
											aria-expanded="false">
											<i data-feather="more-vertical"
												class="text-primary cursor-pointer mr-50"></i>
										</a>
										<div ngbDropdownMenu class="dropdown-menu-right"
											aria-labelledby="dropdownBrowserState">
											<a routerLink="/pedido/gerenciar/isencao/{{row.id_pedido_isencao}}" ngbDropdownItem
												class="d-flex align-items-center"><i data-feather="settings"
													class="mr-50"></i> Gerenciar</a>
											<a (click)="confirmDeleteAlert(row)" ngbDropdownItem
												class="d-flex align-items-center"><i data-feather="trash-2"
													class="mr-50"></i> Excluir</a>
										</div>
									</div>
								</div>
							</ng-template>
						</ngx-datatable-column>

					</ngx-datatable>
				</section>

			</div>
		</div>
	</div>
